import { render } from "./UserProfile.vue?vue&type=template&id=41f40e0d&scoped=true"
import script from "./UserProfile.vue?vue&type=script&scoped=true&lang=js"
export * from "./UserProfile.vue?vue&type=script&scoped=true&lang=js"

import "./UserProfile.vue?vue&type=style&index=0&id=41f40e0d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f40e0d"]])

export default __exports__